if (!customElements.get('sn-option-boxes')) customElements.define('sn-option-boxes', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.groups = [...this.querySelectorAll('fieldset')];
    this.button = this.querySelector('[data-confirm]');
    this.input = this.querySelector('[data-variant-id]');
    this.addEventListener('change', (event) => { event.stopPropagation(); this.update(); });
    if (this.dataset.mode === 'cart') this.button.addEventListener('click', () => this.add());
    this.update();
  }
  update() {
    const selected = this.groups.map(g => g.querySelector('input:checked')?.value);
    this.groups.forEach((group, index) => group.querySelectorAll('input').forEach(input => {
      input.disabled = !this.variants.some(v => v.available && v.options[index] === input.value && selected.every((value, i) => i === index || !value || v.options[i] === value));
    }));
    const variant = this.variants.find(v => v.available && (!this.groups.length || selected.every((value, i) => value && v.options[i] === value)));
    this.input.value = variant ? variant.id : '';
    this.button.disabled = !!this.busy || !variant;
    if (!variant) return;
    const card = this.closest('.snps-card, .sn-upsell-card');
    const price = card?.querySelector('[data-snps-price], .sn-upsell-info b');
    if (price) price.textContent = variant.price;
    const img = card?.querySelector('img');
    if (img && variant.image) { img.src = variant.image; img.removeAttribute('srcset'); }
  }
  async add() {
    if (!this.input.value || this.button.disabled || this.busy) return;
    this.busy = true;
    const drawer = document.querySelector('cart-drawer');
    drawer?.setActiveElement(document.querySelector('#cart-icon-bubble'));
    const status = this.querySelector('[data-option-status]');
    this.button.disabled = true; this.button.setAttribute('aria-busy', 'true'); status.textContent = '';
    try {
      const sections = drawer?.getSectionsToRender().map(s => s.id) || ['cart-icon-bubble'];
      const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items:[{id:Number(this.input.value),quantity:1}], sections, sections_url:location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || this.dataset.retry);
      if (drawer) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'sn-option-boxes',cartData:data});
    } catch (error) { status.textContent = error.message || this.dataset.retry; }
    finally { this.busy = false; this.button.removeAttribute('aria-busy'); this.update(); }
  }
});
